/**
 * @internal — Do NOT import from the barrel (src/components/ui).
 * The barrel re-exports Radix's Badge, which is a different component.
 * Use StatusBadge instead, which wraps this internally.
 */
import React from "react"
import { cva } from "class-variance-authority"
import { cn } from "../../../lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-[var(--radius-md,4px)] px-2 py-0.5 text-[11px] font-medium whitespace-nowrap transition-colors",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground",
        secondary: "bg-secondary text-secondary-foreground",
        destructive: "bg-destructive text-destructive-foreground",
        outline: "border border-border text-foreground",
        "status-success":
          "bg-[var(--status-success-bg)] text-[var(--status-success)]",
        "status-warning":
          "bg-[var(--status-warning-bg)] text-[var(--status-warning)]",
        "status-info":
          "bg-[var(--status-info-bg)] text-[var(--status-info)]",
        "status-danger":
          "bg-[var(--status-danger-bg)] text-[var(--status-danger)]",
        "status-neutral":
          "bg-[var(--status-neutral-bg)] text-[var(--status-neutral)]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

const Badge = React.forwardRef(({ className, variant, ...props }, ref) => {
  return (
    <span ref={ref} className={cn(badgeVariants({ variant }), className)} {...props} />
  )
})
Badge.displayName = "Badge"

export { Badge, badgeVariants }
